import { Typography } from "@material-ui/core";
import { FC, useEffect, useState } from "react";
import Loader from "../../../components/Loader";
import { qar } from "../../../utils/generic";

import { courtDocRef } from "../../../utils/referencies";

const ReservationPrice: FC<any> = (props) => {
  const [price, setPrice] = useState<number>(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async function () {
      setLoading(true);
      try {
        const fetchedData = await courtDocRef(props.record.courtId).get();
        if (fetchedData && fetchedData.exists) setPrice(fetchedData.data()!.price);
        setLoading(false);
      } catch (ex: any) {
        console.log(ex.message);
        setLoading(false);
      }
    })();
  }, []);

  return (
    <Loader loading={loading}>
      <Typography style={{ width: 70 }} color="textSecondary">
        {qar(price)}
      </Typography>
    </Loader>
  );
};

export default ReservationPrice;
